import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "name", "selected", "disabled", "voucherAmountText", "voucherExpiryText", "onChange"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Voucher/VoucherItem.js",
    _this = this;

import React, { useState, useEffect } from 'react';
import { StyledVoucher, StyledLeftCorner, StyledVoucherLeftCorner, StyledVoucherContentCorner, StyledVoucherContent, StyledText, StyledAmount, StyledRightCorner, StyledRightCornerItem, StyledVoucherRightCorner } from './styles';
export var VOUCHER_STATUS = {
  DEFAULT: 'DEFAULT',
  SELECTED: 'SELECTED',
  NOT_AVAILABLE: 'DISABLED'
};
var VOUCHER_STATUS_TO_TEXT = {
  APPLY: 'Apply',
  REMOVE: 'Remove',
  NOT_AVAILABLE: 'Not available'
};

var VoucherItem = function VoucherItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      selected = _ref.selected,
      disabled = _ref.disabled,
      voucherAmountText = _ref.voucherAmountText,
      voucherExpiryText = _ref.voucherExpiryText,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  useEffect(function () {
    if (selected) {
      setStatus(VOUCHER_STATUS.SELECTED);
    } else if (disabled) {
      setStatus(VOUCHER_STATUS.NOT_AVAILABLE);
    } else {
      setStatus(VOUCHER_STATUS.DEFAULT);
    }
  }, [selected, disabled]);

  var handleChangeStatus = function handleChangeStatus() {
    if (!disabled) {
      onChange(id);
    }
  };

  var renderItem = function renderItem() {
    var actionText;

    if (selected) {
      actionText = VOUCHER_STATUS_TO_TEXT.REMOVE;
    } else if (disabled) {
      actionText = VOUCHER_STATUS_TO_TEXT.NOT_AVAILABLE;
    } else {
      actionText = VOUCHER_STATUS_TO_TEXT.APPLY;
    }

    return /*#__PURE__*/React.createElement(StyledText, {
      type: "link",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 12
      }
    }, actionText);
  };

  return /*#__PURE__*/React.createElement(StyledVoucher, {
    type: status,
    onClick: handleChangeStatus,
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(StyledLeftCorner, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(StyledVoucherLeftCorner, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(StyledVoucherContentCorner, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(StyledVoucherContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledText, {
    type: "boldBody",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 11
    }
  }, name), /*#__PURE__*/React.createElement(StyledAmount, {
    type: "sectionTitle",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 11
    }
  }, voucherAmountText), /*#__PURE__*/React.createElement(StyledText, {
    type: "smallBody",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 11
    }
  }, voucherExpiryText))), /*#__PURE__*/React.createElement(StyledRightCorner, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(StyledRightCornerItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }, renderItem()), /*#__PURE__*/React.createElement(StyledVoucherRightCorner, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 9
    }
  })));
};

VoucherItem.defaultProps = {
  selected: false,
  disabled: false,
  'data-testid': 'voucher-item'
};
export default VoucherItem;